import { EmailTemplate } from "@rumble-it/common-lib/types/models/EmailTemplate.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { Button, Card, Input } from "@rumbledirect/ui";
import { Col, Form, Row } from "antd";
import { EmailTemplatePreview } from "./EmailTemplatePreview";

interface EmailTemplateFormCardProps {
  mutation: UseMutationResult<unknown, Error, EmailTemplate, unknown>;
  loading?: boolean;
  initialValues?: EmailTemplate;
  title?: string;
  buttonText?: string;
}

export const EmailTemplateFormCard = ({
  mutation,
  loading,
  initialValues,
  title = "Email Template Aanmaken",
  buttonText = "Aanmaken",
}: EmailTemplateFormCardProps) => {
  const [form] = Form.useForm();
  const html = (Form.useWatch("html", form) as string | undefined) ?? "";

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Card loading={loading} title={title}>
          <Form
            form={form}
            onFinish={mutation.mutate}
            layout="vertical"
            initialValues={initialValues}
          >
            <Form.Item
              rules={[{ required: true, message: "Dit veld is verplicht." }]}
              label="Titel"
              name="title"
            >
              <Input />
            </Form.Item>
            <Form.Item
              rules={[{ required: true, message: "Dit veld is verplicht." }]}
              label="Onderwerp"
              name="subject"
            >
              <Input />
            </Form.Item>
            <Form.Item
              rules={[{ required: true, message: "Dit veld is verplicht." }]}
              label="HTML"
              name="html"
            >
              <Input.TextArea rows={10} />
            </Form.Item>
            <Form.Item label={null}>
              <Button
                loading={mutation.isPending}
                type="primary"
                htmlType="submit"
              >
                {buttonText}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>

      <Col span={12}>
        <EmailTemplatePreview html={html} title="Live Preview" />
      </Col>
    </Row>
  );
};
